import {inject, Injectable} from "@angular/core";
import { APIResponse } from "../../../models/Response";
import {UserPreferences, WorkflowStatusPreferenceForQuickCreateResponse} from "../../../models/userDetails";
import { SharedService } from "../../../services/shared.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import {Observable} from "rxjs";
import {SecureStorageService} from "../../core/services/secure-storage.service";
import {LocalStorageRelatedData} from "../../../local-storage-related-data.model";

@Injectable({
    providedIn: "root",
})
export class UserPreferencesService {
    apiServerUrl = environment.apiBaseUrl;
    private secureStorageService = inject(SecureStorageService)

    constructor(
        private sharedService: SharedService,
        private http: HttpClient,
    ) {}

    getAndSetUserPreferences() {
        let user_id = this.sharedService.getLoggedInUserId();
        this.http
            .get<APIResponse<UserPreferences>>(`${this.apiServerUrl}/userPreference/getUserPreference/${user_id}`)
            .pipe()
            .subscribe({
                next: (res: APIResponse<UserPreferences>) => {
                    this.setUserPreferences(res.data);
                },
            });
    }

    setUserPreferences(userPreferences: UserPreferences) {
        this.secureStorageService.setItem(LocalStorageRelatedData.USER_PREFERENCES, userPreferences);
    }

    getUserPreferencesFromStorage(): UserPreferences | null {
        let userPreferences = this.secureStorageService.getItem<any>(LocalStorageRelatedData.USER_PREFERENCES);
        if (userPreferences) {
            try {
                return userPreferences;
            } catch (e) {
                console.log(e);
                return null;
            }
        } else {
            return null;
        }
    }

    getUserPreferredOrgId(): number | null {
        let userPreferences = this.getUserPreferencesFromStorage();
        if (userPreferences) {
            return userPreferences.orgId;
        } else {
            return null;
        }
    }

    getUserPreferredTeamId(): number | null {
        let userPreferences = this.getUserPreferencesFromStorage();
        if (userPreferences) {
            return userPreferences.teamId;
        } else {
            return null;
        }
    }

    getUserPreferredProjectId(): number | null {
        let userPreferences = this.getUserPreferencesFromStorage();
        if (userPreferences) {
            return userPreferences.projectId;
        } else {
            return null;
        }
    }

    getWorkflowStatusPreferenceForQuickCreate(entityTypeId: number, entityId: number): Observable<APIResponse<WorkflowStatusPreferenceForQuickCreateResponse>> {
        return this.http.get<APIResponse<WorkflowStatusPreferenceForQuickCreateResponse>>(
            `${this.apiServerUrl}/entity-preferences/getPreferenceForQuickCreateCreateUpdate/${entityTypeId}/${entityId}`,
        );
    }
}
